import { ProductImageProps } from './types'

export const findProductImage = (images: Array<ProductImageProps>): ProductImageProps =>
  images?.find((obj) => obj?.field_pv_default) || images[0]
